import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLineChart2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLineChart2"><Path d="M2.5 10.5V19.25M8.83268 4.5V19.25M15.1647 13.5V19.25M21.4967 7.5V19.25" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconLineChart2;
